import React from 'react';
import './Projects.css';

const projects = [
  {
    title: "Portfolio",
    desc: "A modern, responsive portfolio website showcasing my skills and projects with advanced visual effects, glassmorphism design, and interactive contact forms.",
    tech: "React, CSS3, Framer Motion, HTML5",
    github: "https://github.com/gopisankar-id17/portfolio"
  },
  {
    title: "Jewelry Shop Management",
    desc: "A comprehensive management system for jewelry stores featuring inventory tracking, customer management, sales analytics, and billing functionalities.",
    tech: "React, Node.js, MongoDB, Express",
    github: "https://github.com/gopisankar-id17/jewelry-shop-management"
  },
  {
    title: "College Network",
    desc: "A social networking platform for college students to connect, share resources, collaborate on projects, and stay updated with campus events and announcements.",
    tech: "React, Node.js, MySQL, Socket.io",
    github: "https://github.com/gopisankar-id17/college-network"
  },
  {
    title: "AI Powered Smart Ambulance System",
    desc: "An intelligent emergency response system using AI to optimize ambulance routes, predict traffic patterns, and provide real-time medical assistance coordination.",
    tech: "Python, Machine Learning, GPS API, React",
    github: "https://github.com/gopisankar-id17/ai-smart-ambulance-system"
  },
  {
    title: "Stray Dogs Favour",
    desc: "A compassionate platform connecting animal lovers with stray dogs, facilitating adoption, medical care, feeding programs, and community support for street animals.",
    tech: "React, Node.js, MongoDB, Google Maps API",
    github: "https://github.com/gopisankar-id17/stray-dogs-favour"
  },
  {
    title: "Transportation and Logistics System",
    desc: "A comprehensive logistics management solution for tracking shipments, optimizing delivery routes, managing fleet operations, and providing real-time updates to customers.",
    tech: "React, Node.js, PostgreSQL, Google Maps API",
    github: "https://github.com/gopisankar-id17/transportation-logistics-system"
  }
];

function Projects() {
  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <h2 className="section-title">Projects</h2>
        <div className="projects-grid">
          {projects.map((proj, idx) => (
            <div className="project-card" key={idx}>
              <h3>{proj.title}</h3>
              <p>{proj.desc}</p>
              <span className="tech">{proj.tech}</span>
              <div className="project-links">
                <a 
                  href={proj.github} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="github-link"
                >
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="currentColor"
                  >
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                  View Code
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
